/**
 * Phototron SDK
 * 
 * Embeddable 2D Material Viewer and 3D Model Viewer for E-Commerce
 * 
 * @example Basic usage with API
 * ```html
 * <script src="https://cdn.phototron.de/sdk/v1/phototron.min.js"></script>
 * 
 * <phototron-material
 *   asset-id="shoe-001"
 *   api-key="pk_live_xxxxx"
 *   width="400"
 *   height="400">
 * </phototron-material>
 * ```
 * 
 * @example Direct texture URLs
 * ```html
 * <phototron-material
 *   albedo-url="https://example.com/albedo.webp"
 *   normal-url="https://example.com/normal.webp"
 *   specular-url="https://example.com/specular.webp"
 *   width="400"
 *   height="400">
 * </phototron-material>
 * ```
 * 
 * @example Combined Showcase (Click-to-3D)
 * ```html
 * <phototron-showcase
 *   asset-id="shoe-001"
 *   api-key="pk_live_xxxxx"
 *   mode="click-to-3d"
 *   width="600"
 *   height="400">
 * </phototron-showcase>
 * ```
 */

// Core exports
export {
  // Types
  type TextureUrls,
  type LightingConfig,
  type MaterialViewerConfig,
  type ModelViewerConfig,
  type ShowcaseConfig,
  type AssetData,
  type ApiClientConfig,
  DEFAULT_LIGHTING,
  DEFAULT_MATERIAL_CONFIG,
  // WebGL Renderer
  WebGLRenderer,
  type RendererOptions,
  // API Client
  ApiClient,
  ApiError,
  initializeApi,
  getApiClient,
} from './core';

// Web Components
export {
  PhototronMaterial,
  PhototronViewer,
  PhototronShowcase,
} from './components';

// Version
export const VERSION = '1.0.0';

/**
 * Initialize the Phototron SDK with an API key
 * This is a convenience function for initializing the API client
 */
import { initializeApi as _initializeApi } from './core/api-client';

export function init(apiKey: string, options?: { baseUrl?: string }): void {
  _initializeApi({
    apiKey,
    baseUrl: options?.baseUrl,
  });
}
